/**
 * Desktop horizontal filters - one-at-a-time dropdown behavior
 * 
 * Ensures only one filter dropdown is open at a time when clicking filter summaries.
 * Only applies to desktop (min-width: 64rem)
 * 
 * REVERT: Delete this file to restore default Horizon filter behavior
 */

(function () {
  const mq = window.matchMedia('(min-width: 64rem)');
  
  function onClick(e) {
    if (!mq.matches) return;
    
    const bar = e.target.closest('.facets--horizontal');
    if (!bar) return;
    
    const summary = e.target.closest('details > summary');
    if (!summary) return;
    
    // Only intercept clicks directly on the summary itself, not on child elements
    // This allows checkboxes, radios, and other interactive elements to work normally
    if (e.target !== summary && !e.target.classList.contains('facets__label') && !e.target.classList.contains('facets__summary')) {
      return;
    }
    
    const details = summary.parentElement;
    if (!(details && details.tagName === 'DETAILS')) return;
    
    e.preventDefault();
    e.stopPropagation();

    const willOpen = !details.open;
    
    // Close any other open panels first
    bar.querySelectorAll('details.facets__panel[open]').forEach((d) => {
      if (d !== details) d.open = false;
    });
    
    // Toggle the clicked one
    details.open = willOpen;
  }

  document.addEventListener('click', onClick, true);
})();

